<!-- filepath: c:\Users\gabri\Documents\GitHub\medexperts\src\components\LineChart.vue -->
<template>
  <canvas ref="lineChart"></canvas>
</template>

<script>
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.lineChart.getContext('2d');
      new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.data.map(item => item.date), // Apenas a data no eixo X
          datasets: [
            {
              label: 'Taxa de Acertos (%)',
              data: this.data.map(item => ({
                x: item.date, // Data para o eixo X
                y: item.accuracy, // Taxa de acertos para o eixo Y
                name: item.name, // Nome do simulado
              })),
              borderColor: 'rgba(75, 192, 192, 1)',
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              borderWidth: 2,
              fill: true,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
            },
            tooltip: {
              callbacks: {
                // Personaliza o conteúdo do tooltip
                label: function (context) {
                  const point = context.raw; // Acessa o objeto completo do ponto
                  return `Data: ${point.x}, Taxa: ${point.y}%, Simulado: ${point.name}`;
                },
              },
            },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Data',
              },
              ticks: {
                display: window.innerWidth >= 600, // Exibe os rótulos apenas em telas maiores
                autoSkip: true, // Pula automaticamente alguns rótulos
                maxRotation: 0, // Evita rotação dos rótulos
                minRotation: 0,
              },
            },
            y: {
              title: {
                display: true,
                text: 'Taxa de Acertos (%)',
              },
              beginAtZero: true,
              max: 100,
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
canvas {
  max-width: 100%;
  height: auto;
}
</style>